import { PageHero } from "../components/PageHero";
import { FadeUp } from "../components/Reveal";
import { useContent } from "../context/ContentContext";

const makeBlocks = (site) => [
  {
    heading: "Wie is verantwoordelijk?",
    text: `DT Timmerwerken, gevestigd in ${site.location}, is verantwoordelijk voor de verwerking van persoonsgegevens die via deze website worden verstrekt.`,
  },
  {
    heading: "Welke gegevens verzamel ik?",
    text: "Wanneer je het contact- of offerteformulier invult, worden de volgende gegevens verwerkt: je naam, e-mailadres, telefoonnummer (indien ingevuld), het type dienst en de omschrijving van je project.",
  },
  {
    heading: "Waarvoor gebruik ik je gegevens?",
    text: "Je gegevens gebruik ik uitsluitend om contact met je op te nemen over je aanvraag en om een offerte op te kunnen stellen. Je gegevens worden niet verkocht of gedeeld met derden.",
  },
  {
    heading: "Hoe lang bewaar ik je gegevens?",
    text: "Je gegevens worden niet langer bewaard dan noodzakelijk voor het afhandelen van je aanvraag en de eventuele opdracht die daaruit voortkomt.",
  },
  {
    heading: "Je rechten",
    text: "Je hebt het recht om je persoonsgegevens in te zien, te laten corrigeren of te laten verwijderen. Stuur hiervoor een bericht via e-mail, dan handel ik je verzoek zo snel mogelijk af.",
  },
  {
    heading: "Contact",
    text: `Vragen over deze privacyverklaring? Neem contact op via ${site.email} of bel ${site.phoneDisplay}.`,
  },
];

export default function Privacy() {
  const { site } = useContent();
  const blocks = makeBlocks(site);
  return (
    <main data-testid="privacy-page">
      <PageHero
        eyebrow="Privacy"
        title="Privacyverklaring"
        intro="Zo ga ik om met de gegevens die je via deze website met mij deelt."
      />
      <section className="bg-white">
        <div className="mx-auto max-w-[1400px] px-4 pb-14 sm:px-6">
          <div className="max-w-3xl">
            {blocks.map((b, i) => (
              <FadeUp key={b.heading} delay={i * 0.04}>
                <div data-testid={`privacy-block-${i}`} className="border-b border-[#E2E0D9] py-8">
                  <h2 className="font-display text-xl font-bold uppercase tracking-wide text-[#111111]">
                    {b.heading}
                  </h2>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#555555]">
                    {b.text}
                  </p>
                </div>
              </FadeUp>
            ))}
            <FadeUp delay={0.15}>
              <p className="pt-6 text-xs text-[#8E8D8A]">
                Laatst bijgewerkt: juli 2026
              </p>
            </FadeUp>
          </div>
        </div>
      </section>
    </main>
  );
}
